<app-navigation
  (collapseNavigation)="this.collapseNavigation($event)"
  ></app-navigation>
<app-footer [navigationCollapsed]="navigationCollapsed"></app-footer>
